export default {
  init: function(node) {
    console.log('Kadenze.HeroVideo.init...', $(node).data());

    var $wrapper = $(node);
    var existingPlayer = $('iframe', $wrapper);

    if(existingPlayer.length !== 0)
      return;

    var url = '';

    if( $wrapper.data('vimeoId') ) {
      url = 'https://vimeo.com/' + $wrapper.data('vimeoId');
    } else if( $wrapper.data('youtubeId') ) {
      url = 'https://youtu.be/'+$wrapper.data('youtubeId');
    }

    if( url !== '') {
      var player = new Kadenze.IframeMediaPlayer($wrapper, url);
      player.show();
    }
  }
};
